/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateProfileRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/profile_messages.pb'
import {CreateProfileResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/profile_messages.pb'


export const createProfile = (request:CreateProfileRequest, options?: CashRequestOptions) => post<CreateProfileRequest, CreateProfileResponse>("/2.0/cash/create-profile", request, {...options, rejectOnError: true })